import ApiService from '@/services/ApiService';
import { defineStore } from 'pinia';
import { useIdentityStore } from '@/store/IdentityStore';

export const useSprinklerStore = defineStore('sprinkler', {
  state () {
    return {
      sprinklers: null,
      sprinklerSelected: null,
      sprinklerSelectedId: 1,
      models: null,
      modelSelected: null,
      modelSelectedId: 1,
      plates: null,
      plateSelected: null,
      plateSelectedId: 1,
      nozzles: null,
      nozzleSelected: null,
      nozzleSelectedId: 14
    };
  },
  getters: {
    ids () {
      return this.sprinklerSelectedId + ':' + this.modelSelectedId + ':' + this.plateSelectedId + ':' + this.nozzleSelectedId;
    },
    getSprinklers () {
      return this.sprinklers;
    },
    getSprinklerSelected () {
      return this.sprinklerSelected;
    },
    getSprinklerSelectedId () {
      return this.sprinklerSelectedId;
    },
    getModels () {
      return this.models;
    },
    getSelectedModel () {
      return this.modelSelected;
    },
    getModelSelectedId () {
      return this.modelSelectedId;
    },
    getPlates () {
      return this.plates;
    },
    getSelectedPlate () {
      return this.plateSelected;
    },
    getPlateSelectedId () {
      return this.plateSelectedId;
    },
    getNozzles () {
      return this.nozzles;
    },
    getSelectedNozzle () {
      return this.nozzleSelected;
    },
    getNozzleSelectedId () {
      return this.nozzleSelectedId;
    },
  },
  actions: {
    setModels (value) {
      this.models = value;
    },
    setPlates (value) {
      this.plates = value;
    },
    setNozzles (value) {
      this.nozzles = value;
    },
    async fetchSprinklers () {
      return await ApiService.getSprinklers()
        .then((response) => {
          this.sprinklers = [];
          response.data.forEach((item) => {
            this.sprinklers.push({ name: item.name, id: item.id });
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async fetchModels (id) {
      return await ApiService.getModels(id)
        .then((response) => {
          this.models = [];
          response.data.forEach((item) => {
            this.models.push({ name: item.name, id: item.id });
          });
        })
        .catch((error) => {
          this.models = [];
          console.error(error);
        });
    },
    async fetchPlates (id) {
      return await ApiService.getPlates(id)
        .then((response) => {
          this.plates = [];
          response.data.forEach((item) => {
            this.plates.push({ name: item.name, id: item.id, trajectory: item.trajectory });
          });
        })
        .catch((error) => {
          this.plates = [];
          console.error(error);
        });
    },
    async fetchNozzles (id) {
      return await ApiService.getNozzles(id)
        .then((response) => {
          this.nozzles = [];
          this.nozzles = response.data;
        })
        .catch((error) => {
          this.nozzles = [];
          console.error(error);
        });
    },
    setSelection (sprinkler, model, plate, nozzle) {
      this.sprinklerSelected = sprinkler.name;
      this.sprinklerSelectedId = sprinkler.id;
      this.modelSelected = model.name;
      this.modelSelectedId = model.id;
      this.plateSelected = plate.name;
      this.plateSelectedId = plate.id;
      this.nozzleSelected = nozzle.name;
      this.nozzleSelectedId = nozzle.id;
      const identityStore = useIdentityStore(); 
      identityStore.setUserProperty({ Sprinkler: this.sprinklerSelected });
      identityStore.setUserProperty({ Model: this.modelSelected});
      identityStore.setUserProperty({ Plate: this.plateSelected});
      identityStore.setUserProperty({ Nozzle: this.nozzleSelected});

      identityStore.setUserProperty({ Id: this.ids });
    },
    setSprinkler (index, name) {
      this.sprinklerSelected = name;
      this.sprinklerSelectedId = JSON.parse(index);
      const identityStore = useIdentityStore();
      identityStore.setUserProperty({ Sprinkler: name });
      identityStore.setUserProperty({ Id: this.ids });
    },
    setModel (index, name) {
      this.modelSelected = name;
      this.modelSelectedId = index;
      const identityStore = useIdentityStore();
      identityStore.setUserProperty({ Model: name });
      identityStore.setUserProperty({ Id: this.ids });
    },
    setPlate (index, name) {
      this.plateSelected = name;
      this.plateSelectedId = index;
      const identityStore = useIdentityStore();
      identityStore.setUserProperty({ Plate: name });
      identityStore.setUserProperty({ Id: this.ids });
    },
    setNozzle (index, name) {
      this.nozzleSelected = name;
      this.nozzleSelectedId = index;
      const identityStore = useIdentityStore();
      identityStore.setUserProperty({ Nozzle: name });
      identityStore.setUserProperty({ Id: this.ids });
    },
    restoreSprinkler () {
      const identityStore = useIdentityStore();
      let storedSprinkler = identityStore.User.properties.rotator_Sprinkler;
      var storedModel = identityStore.User.properties.rotator_Model;
      let storedPlate = identityStore.User.properties.rotator_Plate;
      let storedNozzle = identityStore.User.properties.rotator_Nozzle;
      let storedIds = identityStore.User.properties.rotator_Id;
      if (storedModel == null || storedNozzle == null || storedSprinkler == null || storedPlate == null || storedIds == null) {
        identityStore.setUserProperty({ Id: this.ids });
        identityStore.setUserProperty({ Sprinkler: this.sprinklerSelected });
        identityStore.setUserProperty({ Model: this.modelSelected });
        identityStore.setUserProperty({ Plate: this.plateSelected });
        identityStore.setUserProperty({ Nozzle: this.nozzleSelected });
        return;
      }
      var ids = storedIds.split(':');
      this.sprinklerSelected = storedSprinkler;
      this.modelSelected = storedModel;
      this.plateSelected = storedPlate;
      this.nozzleSelected = storedNozzle;
      this.sprinklerSelectedId = parseInt(ids[0]);
      this.modelSelectedId = parseInt(ids[1]);
      this.plateSelectedId = parseInt(ids[2]);
      this.nozzleSelectedId = parseInt(ids[3]);
    },

  },
});